import { IFilterBar } from '../models/utilities/filter-bar';
import { AssetSearchFilters } from './models/filters/asset-search-filters';
import { ContainerSearchFilters } from './models/filters/container-search-filters';
import { DriverSearchFilters } from './models/filters/driver-search-filters';
import { PickupSearchFilters } from './models/filters/pickup-search-filters';
import { TruckSearchFilters } from './models/filters/truck-search-filters';

/**
 * Shipments List
 */

        export const TRANSPORTATION_SHIPMENTS_CURRENT_TAB                = 'TRANSPORTATION_SHIPMENTS_CURRENT_TAB';

        /**
         * Action creator for updating the selected tab for shipments
         * @param pageData The new page data
         */
        export const updateSelectedShipmentsTab = (path: string) => ({
            type: TRANSPORTATION_SHIPMENTS_CURRENT_TAB,
            payload: path
        });

/**
 * Pickup List
 */

        export const TRANSPORTATION_PICKUPS_SEARCH_CLEAR_PARAMS    = 'TRANSPORTATION_PICKUPS_SEARCH_CLEAR_PARAMS';
        export const TRANSPORTATION_PICKUPS_SEARCH_UPDATE_FILTERS   = 'TRANSPORTATION_PICKUPS_SEARCH_UPDATE_FILTERS';
        export const TRANSPORTATION_PICKUPS_STARTPOLLING    = 'TRANSPORTATION_PICKUPS_STARTPOLLING';
        export const TRANSPORTATION_PICKUPS_STOPPOLLING     = 'TRANSPORTATION_PICKUPS_STOPPOLLING';
             
        /**
         * Action creator for updating the page data info for shipments
         * @param pageData The new page data
         */
        export const updatePickupSearchFilters = (params: PickupSearchFilters) => ({
            type: TRANSPORTATION_PICKUPS_SEARCH_UPDATE_FILTERS,
            payload: params
        });

        /**
         * Action creator for handling the succesful get of a Shipment
         */
        export const startPollingForShipmentUpdates = () => ({
            type: TRANSPORTATION_PICKUPS_STARTPOLLING
        });

        /**
         * Action creator for handling the succesful get of a Shipment
         */
        export const stopPollingForShipmentUpdates = () => ({
            type: TRANSPORTATION_PICKUPS_STOPPOLLING
        });

        /**
         * Action creator for clearing list data and search parameters
         */
        export const clearPickupSearch = () => ({
            type: TRANSPORTATION_PICKUPS_SEARCH_CLEAR_PARAMS,
            payload: {}
        });

/**
 * Delivery List
 */

        export const TRANSPORTATION_TRUCKS_SEARCH_CLEAR_FILTERS    = 'TRANSPORTATION_TRUCKS_SEARCH_CLEAR_FILTERS';
        export const TRANSPORTATION_TRUCKS_SEARCH_UPDATE_FILTERS   = 'TRANSPORTATION_TRUCKS_SEARCH_UPDATE_FILTERS';

        /**
         * Action creator for updating the page data info for deliveries
         * @param pageData The new page data
         */
        export const updateTruckSearchFilters = (params: TruckSearchFilters) => ({
            type: TRANSPORTATION_TRUCKS_SEARCH_UPDATE_FILTERS,
            payload: params
        });

        /**
         * Action creator for clearing list data and search parameters
         */
        export const clearTruckSearch = () => ({
            type: TRANSPORTATION_TRUCKS_SEARCH_CLEAR_FILTERS,
            payload: {}
        });

/**
 * Asset List
 */

        export const TRANSPORTATION_FLEET_ASSETS_SEARCH_CLEAR_FILTERS   = 'TRANSPORTATION_FLEET_ASSETS_SEARCH_CLEAR_FILTERS';
        export const TRANSPORTATION_FLEET_ASSETS_SEARCH_UPDATE_FILTERS  = 'TRANSPORTATION_FLEET_ASSETS_SEARCH_UPDATE_FILTERS';
        export const TRANSPORTATION_FLEET_CURRENT_TAB                   = 'TRANSPORTATION_FLEET_CURRENT_TAB';

        /**
         * Action creator for updating the selected tab for shipments
         * @param pageData The new page data
         */
        export const updateSelectedFleetTab = (path: string) => ({
            type: TRANSPORTATION_FLEET_CURRENT_TAB,
            payload: path
        });

        /**
         * Action creator for updating the page data info for assets
         * @param pageData The new page data
         */
        export const updateAssetSearchFilters = (params: AssetSearchFilters) => ({
            type: TRANSPORTATION_FLEET_ASSETS_SEARCH_UPDATE_FILTERS,
            payload: params
        });

        /**
         * Action creator for clearing list data and search parameters
         */
        export const clearAssetSearch = () => ({
            type: TRANSPORTATION_FLEET_ASSETS_SEARCH_CLEAR_FILTERS,
            payload: {}
        });

/**
 * Driver List
 */

        export const TRANSPORTATION_FLEET_DRIVERS_SEARCH_CLEAR_FILTERS    = 'TRANSPORTATION_FLEET_DRIVERS_SEARCH_CLEAR_FILTERS';
        export const TRANSPORTATION_FLEET_DRIVERS_SEARCH_UPDATE_FILTERS   = 'TRANSPORTATION_FLEET_DRIVERS_SEARCH_UPDATE_FILTERS';

        /**
         * Action creator for updating the page data info for drivers
         * @param pageData The new page data
         */
        export const updateDriverSearchFilters = (params: DriverSearchFilters) => ({
            type: TRANSPORTATION_FLEET_DRIVERS_SEARCH_UPDATE_FILTERS,
            payload: params
        });

        /**
         * Action creator for clearing list data and search parameters
         */
        export const clearDriverSearch = () => ({
            type: TRANSPORTATION_FLEET_DRIVERS_SEARCH_CLEAR_FILTERS,
            payload: {}
        });

/**
 * Container List
 */

        export const TRANSPORTATION_CONTAINERS_SEARCH_CLEAR_FILTERS    = 'TRANSPORTATION_CONTAINERS_SEARCH_CLEAR_FILTERS';
        export const TRANSPORTATION_CONTAINERS_SEARCH_UPDATE_FILTERS   = 'TRANSPORTATION_CONTAINERS_SEARCH_UPDATE_FILTERS';

        /**
         * Action creator for updating the page data info for containers
         * @param pageData The new page data
         */
        export const updateContainerSearchFilters = (params: ContainerSearchFilters) => ({
            type: TRANSPORTATION_CONTAINERS_SEARCH_UPDATE_FILTERS,
            payload: params
        });

        /**
         * Action creator for clearing list data and search parameters
         */
        export const clearContainerSearch = () => ({
            type: TRANSPORTATION_CONTAINERS_SEARCH_CLEAR_FILTERS,
            payload: {}
        });

/**
 * Planning List
 */

        export const TRANSPORTATION_PLANNING_CURRENT_TAB                = 'TRANSPORTATION_PLANNING_CURRENT_TAB';
        export const TRANSPORTATION_PLANNING_DELIVERY_UPDATE_FILTERS    = 'TRANSPORTATION_PLANNING_DELIVERY_UPDATE_FILTERS';
        export const TRANSPORTATION_PLANNING_DELIVERY_CLEAR_FILTERS     = 'TRANSPORTATION_PLANNING_DELIVERY_CLEAR_FILTERS';

        /**
         * Action creator for updating the selected tab for planning
         * @param pageData The new page data
         */
        export const updateSelectedPlanningTab = (path: string) => ({
            type: TRANSPORTATION_PLANNING_CURRENT_TAB,
            payload: path
        });

        /**
         * Action creator for updating the page data info for truck planning
         * @param pageData The new page data
         */
        export const updateDeliveryPlanningFilters = (params: IFilterBar) => ({
            type: TRANSPORTATION_PLANNING_DELIVERY_UPDATE_FILTERS,
            payload: params
        });

        /**
         * Action creator for clearing list data and search parameters
         */
        export const clearDeliveryPlanningFilters = () => ({
            type: TRANSPORTATION_PLANNING_DELIVERY_CLEAR_FILTERS,
            payload: {}
        });

